import {Quikr} from 'q-components/components/icons/headerIcons';

function isMobileRequest() {
        if (typeof window != "undefined" && typeof window.__PRELOADED_STATE__ != 'undefined' && typeof window.__PRELOADED_STATE__.isMobile != 'undefined') {
            return window.__PRELOADED_STATE__.isMobile;
        } else {
            return true;
        }
}

function isWebViewRequest() {
  if (typeof window != "undefined" && typeof window.__PRELOADED_STATE__ != "undefined" && typeof window.__PRELOADED_STATE__.isWebView != "undefined") {
    return window.__PRELOADED_STATE__.isWebView;
  }
  return false;
}

function logoCallBack(props,context) {
    if (isMobileRequest()) {
        return <a href={`https://www.quikr.com`} class="logo" ><Quikr class="mdc-toolbar__icons" /><span class="link-text-hidden">Quikr</span></a>
    } else {
        const { match: { params : { type } } } = props;
        let logoUrl  = 'https://teja8.kuikr.com/module_assets/images/quikr_logo.png';
        let href = 'https://www.quikr.com';
        return <a href={href} class="logo" ><img src={logoUrl} class="quikrs-logo"/><span class="link-text-hidden">Quikr</span></a>
    }
}

let config = [
  {
    route: {
      path: "/securepaymentpage",
      exact: true
    },
    pageType: "pwaPaymentPage",
    header: {
      show: false
    },
    footer: {
      show: false
    }
  },
  {
    route: {
      path: "/wallet",
      exact: true
    },
    pageType: "quikrWalletDetails",
    header: {
      show: !isWebViewRequest(),
      searchCityCallback:(cityId, cityName, g_id, match,prevcity) => {
        let currentLocation = window.location.href;
        window.location = currentLocation;
      },
      logoCallback: logoCallBack,
      cityModal: true
    },
    search: {
      show: !isWebViewRequest()
    },
    footer: {
      show: false
    }
  },
  {
    route: {
      path: "/giftcards",
      exact: true
    },
    pageType: "activeGiftCards",
    header: {
      show: !isWebViewRequest(),
      searchCityCallback:(cityId, cityName, g_id, match,prevcity) => {
        let currentLocation = window.location.href;
        window.location = currentLocation;
      },
      logoCallback: logoCallBack,
      cityModal: true
    },
    search: {
      show: !isWebViewRequest()
    },
    footer: {
      show: false
    }
  },
{
    route: {
        path: "/giftcard/categories",
            exact: true
    },
    pageType: "giftCardCategory",
        header: {
    show: !isWebViewRequest(),
        searchCityCallback:(cityId, cityName, g_id, match,prevcity) => {
        let currentLocation = window.location.href;
        window.location = currentLocation;
    },
    logoCallback: logoCallBack,
        cityModal: true
},
    search: {
        show: !isWebViewRequest()
    },
    footer: {
        show: false
    }
},
  {
    route: {
      path: '/giftcard/details',
      exact: true
    },
    pageType: "giftCardDetails",
    header: {
      show: !isWebViewRequest(),
      searchCityCallback:(cityId, cityName, g_id, match,prevcity) => {
        let currentLocation = window.location.href;
        window.location = currentLocation;
      },
      logoCallback: logoCallBack,
      cityModal: true
    },
    search: {
      show: !isWebViewRequest()
    },
    footer: {
      show: false
    }
  }
];

export default config;



// WEBPACK FOOTER //
// ../q-monetization/src/shellConfig.js